/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-21 09:28:47
 * @LastEditTime: 2019-08-23 15:00:01
 * @LastEditors: Please set LastEditors
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import '@/utils/getCurrentLanguage'
import App from "./App";
import '@/utils/firebase'
import router from "./router";
Vue.config.productionTip = false;

import "@/utils/rem";
import "@/assets/css/global.scss";

import UeIcon from "./compontents/newHome/UeIcon.vue"; //引入新首页公共ICON

//newIndex
// import "../src/assets/newCss/entry.scss";




import "@/icons/index";
// @import "../uemo-icon-font/fonts/ueicon.css";
// @import "./var.scss";
// @import "./reset.scss";

import "./assets/font/font.css";
import "babel-polyfill";
import "./utils/isMobile";
/* eslint-disable no-new */
import promise from "es6-promise";
import i18n from "./i18n/i18n";
import store from "./store";
import DirectiveLoading from "./directiveLoading"; //自定义loading
import { VueMasonryPlugin } from "vue-masonry";
import lottie from "vue-lottie";
import { Lazyload, DatetimePicker, Popup } from "vant";
import { IsShow } from "@/utils/utilsType";
import VueLuckyCanvas from '@lucky-canvas/vue'
// import Vconsole from 'vconsole' //查看H5控制台插件
Vue.use(DirectiveLoading);
Vue.use(VueMasonryPlugin);
Vue.use(Lazyload);
Vue.use(DatetimePicker);
Vue.use(Popup);
Vue.use(VueLuckyCanvas)

Vue.component("lottie", lottie);
Vue.component("UeIcon", UeIcon);
// new Vconsole() //查看H5控制台插件使用
// 注册 ps:要在aixo之前注册
promise.polyfill();
// 导入极验
require("./assets/js/gt");
Vue.prototype.$initGeet = initGeetest4;
Vue.prototype.IsShow = IsShow;
import JsBridge from "@/utils/jsBridge-plugin";
Vue.use(JsBridge);

console.log(process.env.NODE_ENV);
new Vue({
  el: "#app",
  router,
  i18n,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js